<template>
    <div>
       <Breadtabsheader/>
        <div class="h-content">
            <div class="h-piece">
                <div class="h-formBox">
                    <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder">
                        <div class="h-thirdColumn w-newColumn">

                            <el-form-item label="关键字">
                                <el-input clearable v-model="q.keyword"></el-input>
                            </el-form-item>

                            <el-form-item label="产业链群">
                                <el-input clearable v-model="q.industry"></el-input>
                            </el-form-item>

                        </div>
                        <div class="h-formBtnOut h-columnCenter">
                            <el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
                            <el-button class="h-btn h-formBtn h-bggreen" icon="el-icon-plus"
                                       @click="createdict">新建关键字</el-button>
                        </div>
                    </el-form>
                </div>
            </div>
            <div class="h-table h-mrt30">
                <el-table
                        @selection-change="handleSelectionChange"
                        ref="ddtable"
                        :data="tableData"
                        stripe
                        border
                        style="width: 100%"
                >
                    <el-table-column
                            type="selection"
                            width="40"
                            :label="all"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="keyword"
                        label="关键字"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="industry"
                        label="产业链群"
                    >
                    </el-table-column>

                    <el-table-column
                        prop="type"
                        label="方案分类"
                        width="100" >
                    <template slot-scope="scope">
                        <span v-if="scope.row.type == 1">产品</span>
                        <span v-if="scope.row.type == 2">方案</span>
                    </template>

                    </el-table-column>

                    <el-table-column
                        prop="remark"
                        label="备注"
                    >
                    </el-table-column>


                    <el-table-column
                        prop="cuname"
                        label="创建人"
                        width="120"
                    >
                    </el-table-column>

                    <el-table-column
                            prop="cdate"
                            label="创建时间"
                            width="120"
                    >
                    </el-table-column>

                    <el-table-column
                            prop="lucode"
                            label="修改人"
                            width="120"
                    >
                    </el-table-column>
                    <el-table-column
                            prop="ldate"
                            label="修改时间"
                            width="120"
                    >
                    </el-table-column>

                    <el-table-column
                            fixed="right"
                            label="操作"  >
                        <template slot-scope="scope">
                            <el-button
                                    class="h-tableLink h-btn"
                                    @click="handleEdit(scope.row)">修改</el-button>
                            <el-button
                                    class="h-tableLink h-btn"
                                    @click="handleDelete(scope.row)">删除</el-button>
                        </template>
                    </el-table-column>

                </el-table>
                <div class="h-tableBL" style="margin:20px 0 0 20px;display:flex;justify-content:space-between">
                    <div>
                        <el-button
                                class="h-btn h-formBtn h-bgblueQ"
                                icon="h-el-icon h-el-icon-import"
                                style="margin-left:-20px;"
                                @click="exportExcel" >
                            批量导出
                        </el-button>

                    </div>
                    <div style="display:flex;justify-content: space-between;flex-direction:row-reverse;margin-top:20px">
                        <pagination :page="q" @query="query"/>
                    </div>
                </div>
            </div>

            <div>
                <el-dialog :close-on-click-modal="false" :visible.sync="dialogFormVisible" class="h-dialog2">
                    <div class="h-dialogImg">
                        <div class="h-disTable">
                            <div class="h-tableCell">
                                <h1>修改（新建）负责人</h1>
                            </div>
                        </div>
                    </div>
                    <div class="h-formLine">
                        <el-form ref="form" :model="f"
                                 :inline="true"  class="demo-ruleForm h-formbLine h-dialogForm">


                            <el-form-item label="关键字" prop="keyword" :rules="[
                                          { required: true, message: '请填写关键字', trigger: 'blur'},
                                        ]" class="h-elformWrap-2">

                                <el-input v-model.trim="f.keyword" ></el-input>
                            </el-form-item>

                            <el-form-item label="产业链群" prop="industry" :rules="[
                                          { required: true, message: '请输产业链群', trigger: 'blur'},
                                        ]" class="h-elformWrap-2">
                                <el-input v-model.trim="f.industry" ></el-input>
                            </el-form-item>


                            <el-form-item label="方案分类" prop="type" :rules="[
                                          { required: true, message: '请选择方案分类', trigger: 'blur'},
                                        ]" class="h-elformWrap-2">
                                <el-select v-model="f.type" placeholder="请选择">
                                    <el-option label="产品" value="1"></el-option>
                                    <el-option label="方案" value="2"></el-option>
                                </el-select>
                            </el-form-item>

                            <el-form-item label="备注" prop="remark"  class="h-elformWrap-2">
                                <el-input v-model.trim="f.remark"></el-input>
                            </el-form-item>


                        </el-form>
                    </div>
                    <div slot="footer" class="dialog-footer">
                        <el-button class="h-btn h-formBtn h-bgwhite" @click="closeM">取 消</el-button>
                        <el-button class="h-btn h-formBtn h-bgblue2" @click="saveOrUpdate">提交保存</el-button>
                    </div>
                </el-dialog>
            </div>
        </div>
    </div>
</template>
<script>

    import ss from "@/api/SystemService";
    import updownfile from '../../../utils/updownfile'
    import clueIndustryKeyword from "@/api/guanhuai/clueIndustryKeyword";
    export default {
        components: {

        },
        data() {

            return {
                uploaddownexcelflag: false,

                showYonghuflag: false,
                //table列表
                tableData: [],
                shenglist: [],
                //查询属性
                q: {
                    keyword:null,
                    industry:null,
                    pageSize: 10,
                    pageNo: 1,
                    total: 0,
                },
                //表单
                f:{
                    id:null,
                    keyword:null,
                    industry:null,
                    type:null,
                    remark:null,


                },
                optflag:'save',
                //弹出框
                dialogFormVisible: false,
                //表格
                multipleSelection: [],
            }
        },
        created() {
            this.query();
            this.loadArea();
        },
        methods: {

            loadArea() {
                let proSelect = {
                    pcode: 0,
                    level: 1,
                }
                ss.Dictservice.arealist(proSelect).then(rd => {
                    this.shenglist = rd;
                })
            },

            selectUser(){


            },


            query() {
                ss.clueIndustryKeyword.selectPage(this.q).then(rd => {
                    this.q.total = rd.total;
                    this.tableData = rd.records;
                })
            },

            handleFilter() {
                this.query();

            },
            createdict(){
                this.f={};

                this.dialogFormVisible = true;
                this.optflag = 'save'
            },
            handleEdit(obj){
                //设置提交的字段

                this.f =obj;

                this.dialogFormVisible = true;
                this.optflag = 'update'
            },
            handleDelete(obj){
                this.$msg.confirm("确认删除?",()=>{
                    ss.clueIndustryKeyword.deleteById({id:obj.id}).then(rd=>{
                        this.$msg.msgs("删除成功！");
                        this.query();
                    });
                })
            },
            //保存数据字典
            saveOrUpdate(){
                this.$refs['form'].validate((valid) => {
                    if (valid) {

                        var retobj = null;
                        if(this.optflag == 'save'){
                            retobj = ss.clueIndustryKeyword.insert(this.f);
                        }else if(this.optflag =="update"){
                            retobj = ss.clueIndustryKeyword.updateById(this.f);
                        }
                        retobj.then(rd=>{
                            this.dialogFormVisible = false;
                            this.$msg.msgs("操作成功！");
                            this.f={};
                            this.query();
                        });
                    } else {
                        return false;
                    }
                });
            },
            //关闭
            closeM(){

                this.f={};
                this.dialogFormVisible = false;

            },

            //选中
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            //明细导出
            exportExcel() {
                var idlist = [];
                this.multipleSelection.forEach(element => {
                    idlist.push(element.id);
                });
                updownfile.down("/api/swyl/v1/demo/bscClueIndustryKeyword/downloadExcel", idlist, "get", 'data');
            },
            //导入Excel
            uploaddownexcelflagbtn() {
                this.uploaddownexcelflag = true;
            },
            uploadExcelFilecallback(rd) {
                this.query();
                this.$msg.msgs(rd.msg);
            },
        }
    }
</script>
